import { LocationIconWrapper } from './IconWrapper';
import { LocationData } from './LocationTypes';
import { ReactComponent as LocationIcon} from './assets/icons/location.svg';
import './AddressField.css'

const AddressField = ({ location } : {location : LocationData} ) => {
  const { street, postCode, municipality } = location;

  if (!street) return null;

  return (
    <div className='flexRow'>
      <LocationIconWrapper>
        <LocationIcon />
      </LocationIconWrapper>
      <p className='add-text'>
        {`${!!street ? street : ''}, ${!!postCode ? postCode : ''} ${!!municipality ? municipality : ''
          }`}
      </p>
    </div>
  );
};

export default AddressField;
